
































import { AnagraficaRequest } from '@/models/anagrafica.model';
import { Specializzazione, SpecializzazioneVoce, SpecializzazioneAttivita } from '@/models/specializzazione.model';
import { AnagraficaService } from '@/services/anagrafica.service';
import { SpecializzazioneService } from '@/services/specializzazione.service';
import { Component, Prop, Vue, Inject, Watch } from 'vue-property-decorator';


@Component({})
export default class StpSearch extends Vue {

	@Inject('AnagraficaService')
	anagraficaService!: AnagraficaService;

	searchparam: AnagraficaRequest;


	constructor() {
		super();
		this.searchparam = new AnagraficaRequest();
		this.searchparam.stp = true;
	}

	get config() {
		return JSON.parse(process.env.VUE_APP_SEARCH);
	}


	search() {
		this.$emit('search', this.searchparam)
	}

	reset() {
		this.searchparam = new AnagraficaRequest();
		this.searchparam.stp = true;
	}

}
